export enum OfferModificationDestination {
    AC_VARIANTS = 'AC_VARIANTS',
    ADDITIONAL_OPTIONS = 'ADDITIONAL_OPTIONS',
}
